import { AppBar, Box, CircularProgress, Stack, Toolbar, Typography } from '@mui/material';

import { BrandLogoWhite, Footer, LEFT_RAIL_WIDTH, useBrandVersion } from 'common';
import { useSignupBuyerBrandSync } from '../pages/Supplier/useSignupBuyerBrandSync';

const SUPPLIER_TERMS_OF_SERVICE_URL =
    'https://archive.transcepta.com/resources/Transcepta%20Terms%20of%20Service_SP.pdf';

export function Layout({ children }: { children: React.ReactNode }) {
    const { isBrandReady } = useSignupBuyerBrandSync();
    const isNewBrand = useBrandVersion() === 'newBrand';

    if (!isBrandReady) {
        return (
            <Box
                sx={{
                    minHeight: '100vh',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    backgroundColor: 'grey.100',
                }}
            >
                <CircularProgress />
            </Box>
        );
    }

    return (
        <Stack sx={{ height: '100vh', overflow: 'hidden', backgroundColor: 'grey.100' }}>
            <AppBar
                position="static"
                elevation={isNewBrand ? 0 : undefined}
                sx={{
                    backgroundColor: isNewBrand ? 'primary.main' : 'primary.800',
                }}
            >
                <Toolbar
                    disableGutters={isNewBrand}
                    sx={{
                        justifyContent: {
                            sm: 'initial',
                            xs: 'center',
                        },
                    }}
                >
                    {/* Matches the left nav rail's width + left inset so branding lines up with it. */}
                    <Box
                        sx={
                            isNewBrand
                                ? {
                                      width: LEFT_RAIL_WIDTH,
                                      boxSizing: 'border-box',
                                      pl: 2,
                                      display: 'flex',
                                      alignItems: 'center',
                                  }
                                : { mx: 4, my: 1, alignItems: 'center' }
                        }
                    >
                        <BrandLogoWhite />
                    </Box>
                    <Typography
                        variant="subtitle1"
                        noWrap
                        component="div"
                        sx={{
                            flexGrow: 1,
                            display: {
                                sm: 'block',
                                xs: 'none',
                            },
                            ...(isNewBrand && { pl: 2 }),
                        }}
                    >
                        {isNewBrand ? 'Supplier Onboarding' : 'Invoices & Electronic Payments'}
                    </Typography>
                </Toolbar>
            </AppBar>
            <Box
                component="main"
                sx={{
                    flexGrow: 1,
                    height: '0px',
                    minHeight: 0,
                }}
            >
                <Box
                    sx={{
                        height: '100%',
                        overflowY: 'auto',
                    }}
                >
                    {children}
                </Box>
            </Box>
            <Footer compact termsOfServiceURL={SUPPLIER_TERMS_OF_SERVICE_URL} />
        </Stack>
    );
}
